<!--
 * @Author: hongye
 * @Date: 2020-09-23 13:57:17
 * @LastEditTime: 2021-04-28 11:07:45
 * @Description: 
-->
<template>
  <div>
       <h3 class="online_doc_h3" v-show="title">{{title}}</h3>
          <el-table v-if='dataList.length' :data="dataList" border style="width: 100%;border-radius: 4px;">
            <el-table-column prop="name" :label="$t('onlineDoc.属性名')"></el-table-column>
            <el-table-column prop="type" :label="$t('onlineDoc.属性类型')"></el-table-column>
            <el-table-column prop="require" :label="$t('onlineDoc.是否必填')"></el-table-column>
            <el-table-column prop="normal" :label="$t('onlineDoc.示例')"></el-table-column>
            <el-table-column prop="describe" :label="$t('onlineDoc.描述')">
              <template slot-scope="scope">
                  <div v-html="scope.row.describe"></div>
              </template>
            </el-table-column>
          </el-table>
  </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:""
        },
        dataList:{
            type:Array,
            default:function(){
                return [];
            }
        }
    }
}
</script>

<style lang="scss" scoped>

  .online_doc_h3 {
    color: #666666;
    font-size: 16px;
    line-height: 32px;
    margin-bottom: 15px;
  }
</style>